import React from "react";
import { Grid, Typography } from "@mui/material";

const NoLicenseSelected = () => {
  return (
    <div style={{ marginTop: "20%" }}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={3}>
          <Typography
            sx={{ fontWeight: "550", fontSize: ".8rem", textAlign: "center" }}
          >
            No License selected
          </Typography>
        </Grid>
        <Grid item>
          <Typography sx={{ fontWeight: "500", fontSize: ".75rem", color: "grey" }}>
            Select a license from the left panel to preview its details here.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default NoLicenseSelected;
